<div class="chart-container-full">
  <highcharts-chart [Highcharts]="highcharts" [options]="chartOptions" [(update)]="updateFlag">
  </highcharts-chart>
</div>